import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { SignUpLink } from '../SignUp';
import { PasswordForgetLink } from '../PasswordForget';
import { Link } from "react-router-dom"
import { withFirebase } from '../../../services/Firebase';
import * as ROUTES from '../../../constants/routes';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, FormGroup, Form, Input, Button, Label } from 'reactstrap';
import Checkbox from "../../../theme/@vuexy/checkbox/CheckboxesVuexy"
import { Mail, Lock, Check, Facebook, Twitter, GitHub } from "react-feather"
import { history } from "../../../history"
import googleSvg from "../../../assets/img/svg/google.svg"
import classnames from "classnames"
import FirebaseService from '../../../services/impl/firebase/FirebaseService';

const SignInPage = () => (
  <div>
    <LoginPage />
  </div>
);

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

const ERROR_CODE_ACCOUNT_EXISTS =
  'auth/account-exists-with-different-credential';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with an E-Mail address to
  this social account already exists. Try to login from
  this account instead and associate your social accounts on
  your personal account page.
`;

const oldPage = () => <div>
  <SignInForm />
  <SignInGoogle />
  <SignInFacebook />
  <SignInTwitter />
  <PasswordForgetLink />
  <SignUpLink />
</div>;


class LoginPage extends React.Component {
  state = {
    activeTab: "1"
  }

  toggle = (tab) => {
    this.setState({ activeTab: tab });
  }

  render() {
    const rand = Math.floor((Math.random() * 1000));
    return (
      <Container>
        <Row>
          <Col></Col>
          <Col className="sign-in-page">
            <div className="container">
            <Card className="centeralign">
              <CardHeader className="pb-1">
                <CardTitle>
                  <h4 className="mb-0">Login to Sales Play</h4>
                </CardTitle>
              </CardHeader>
              <p className="px-2 auth-title">
                Welcome back, please login to your account.
                </p>
              <SignInForm />
            </Card>
            </div>
            </Col>
          <Col></Col>
        </Row>
      </Container>
    );
  }
}

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email, password } = this.state;

    FirebaseService.getInstance()
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.DASHBOARD);
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error } = this.state;

    const isInvalid = password === '' || email === '';

    return (
      <React.Fragment>
        <CardBody className="pt-1">
          <Form action="/" onSubmit={this.onSubmit}>
            <FormGroup className="form-label-group position-relative has-icon-left">
              <Input
                name="email"
                value={email}
                onChange={this.onChange}
                type="text"
                placeholder="Email Address"
                required
              />
              <div className="form-control-position">
                <Mail size={15} />
              </div>
              <Label>Email</Label>
            </FormGroup>
            <FormGroup className="form-label-group position-relative has-icon-left">
              <Input
                name="password"
                value={password}
                onChange={this.onChange}
                type="password"
                placeholder="Password"
                required
              />
              <div className="form-control-position">
                <Lock size={15} />
              </div>
              <Label>Password</Label>
            </FormGroup>
            <FormGroup className="d-flex justify-content-between align-items-center">
              <Checkbox
                color="primary"
                icon={<Check className="vx-icon" size={16} />}
                label="Remember me"
                defaultChecked={false}
                onChange={this.handleRemember}
              />
              {/*<div className="float-right">
                <Link to="/pages/forgot-password">Forgot Password?</Link>
              </div>*/}
            </FormGroup>
            <div className="d-flex justify-content-between">
              { <SignUpLink /> }
              <Button disabled={isInvalid} color="primary" type="submit">
                Login
              </Button>
            </div>
          </Form>
          <div className="error">
            {error && <p>{error.message}</p>}
          </div>
        </CardBody>

        {/* <div className="auth-footer mr-5">
          <div className="divider">
            <div className="divider-text">OR</div>
          </div>
          <div className="footer-btn d-flex justify-content-center">
            <SignInFacebookBase />
            <SignInTwitterBase />
            <SignInGoogleBase />
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}

class SignInGoogleBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = event => {
    this.props.firebase
      .doSignInWithGoogle()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return this.props.firebase.user(socialAuthUser.user.uid).set({
          username: socialAuthUser.user.displayName,
          email: socialAuthUser.user.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.HOME);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

    event.preventDefault();
  };

  render() {
    const { error } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <Button
          className="btn-google mr-2"
          color=""
          type="submit"
        >
          <img src={googleSvg} alt="google" height="15" width="15" />
        </Button>

        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

class SignInFacebookBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = event => {
    this.props.firebase
      .doSignInWithFacebook()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return this.props.firebase.user(socialAuthUser.user.uid).set({
          username: socialAuthUser.additionalUserInfo.profile.name,
          email: socialAuthUser.additionalUserInfo.profile.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.HOME);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

    event.preventDefault();
  };

  render() {
    const { error } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <Button
          className="btn-facebook mr-2"
          color=""
          type="submit"
        >
          <Facebook size={14} />
        </Button>

        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

class SignInTwitterBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = event => {
    FirebaseService.getInstance()
      .doSignInWithTwitter()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return FirebaseService.getInstance().user(socialAuthUser.user.uid).set({
          username: socialAuthUser.additionalUserInfo.profile.name,
          email: socialAuthUser.additionalUserInfo.profile.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.HOME);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

    event.preventDefault();
  };

  render() {
    const { error } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <Button
          className="btn-twitter mr-2"
          color=""
          type="submit"
        >
          <Twitter size={14} stroke="white" />
        </Button>

        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

const SignInForm = compose(
  withRouter,
  withFirebase,
)(SignInFormBase);

const SignInGoogle = compose(
  withRouter,
  withFirebase,
)(SignInGoogleBase);

const SignInFacebook = compose(
  withRouter,
  withFirebase,
)(SignInFacebookBase);

const SignInTwitter = compose(
  withRouter,
  withFirebase,
)(SignInTwitterBase);

export default SignInPage;

export { SignInForm, SignInGoogle, SignInFacebook, SignInTwitter };
